import React, { useState } from 'react';
import { Button, Text, View } from "../../Components/Themed";
import { FlatList } from 'react-native';
import type { GroupPlayerProps } from '../../types';
import { Switch } from '../../Components';
import { GroupApi } from '../api';
import { useColors } from '../../constants/useColors';

const sections = ['header','settings']
type MySettingsFormProps = {
    group_player:GroupPlayerProps,
    onUpdateGroupPlayer:(group_player:GroupPlayerProps) => void,
    onClose:() => void
}
type GroupSettingProps = {
    group_key:string, label: string, settings: SettingProps[]
}
type SettingProps = {
    setting_key:string, label:string, description:string 
}
const settings = [
    { 
        group_key: 'settings', label: 'My Group Settings', settings: [
            { setting_key: 'leaderboard', label: 'Leaderboard', description: "Allow your account to be included in the leaderboard" },
            { setting_key: 'activity', label: 'Show Activity', description: "Show your BettorEdge activity under the activity tab" },
        ]
    },
    { 
        group_key: 'notifications', label: 'My Notification Settings', settings: [
            { setting_key: 'chat_notifications', label: 'Chat', description: "Get notified of new messages in this chat" },
            { setting_key: 'member_notifications', label: 'Members', description: "Get notified when new members join the group" },
            { setting_key: 'activity_notifications', label: 'Activity', description: "Get notified of player activity in this group. Once enabled - you can select the individual members to follow from the group screen."}
        ]
    }
]
const MySettingsForm = ({ group_player, onUpdateGroupPlayer, onClose }: MySettingsFormProps ) => {
    const Colors = useColors();
    const [ manage_state, setState ] = useState<{
        loading:string | undefined,
    }>({
        loading:undefined
    });
    const { loading } = manage_state;

    const handleSave = async(gp:GroupPlayerProps, setting_key:string) => {
        if(!gp){ return }
        if(loading){ return }
        setState({ ...manage_state, loading: setting_key });
        let new_gp = await GroupApi.updateGroupPlayer(gp);
        if(!new_gp){
            alert('Unable to process request')
            return setState({ ...manage_state, loading:undefined })
        }
        onUpdateGroupPlayer(new_gp);
        setState({ ...manage_state, loading: undefined })
    }

    const renderSettings = (data:{ item: SettingProps, index:number }) => {
        const setting = group_player[data.item.setting_key as keyof GroupPlayerProps]
        const setting_value = setting ? true : false
        const is_loading = loading == data.item.setting_key ? true : false
        return (
            <View transparent type='row' style={{ borderBottomWidth:1, borderColor:Colors.borders.light, padding:10 }}>
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>{data.item.label}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{data.item.description}</Text>
                </View>
                <Switch loading={is_loading} value={setting_value} switch_type='on_off' onChange={async(val) => {
                    if(data.item.setting_key == 'activity_notifications'){
                        let new_val = val ? [] : undefined
                        return handleSave({ ...group_player, [data.item.setting_key]: new_val }, data.item.setting_key)
                    }
                    return handleSave({ ...group_player, [data.item.setting_key]: val }, data.item.setting_key)
                }} />
            </View>
        )
    }

    const renderGroupSettings = (data:{ item:GroupSettingProps, index:number }) => {
        return (
            <View float style={{ margin:10 }}>
                <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                    <View transparent style={{ flex:1 }}>
                        <Text theme='h1'>{data.item.label}</Text>
                    </View>
                </View>
                <View transparent style={{ padding:10 }}>
                    <FlatList
                        data={data.item.settings}
                        key={`${data.item.group_key}_settings`}
                        keyExtractor={item => item.setting_key}
                        renderItem={renderSettings}
                    />
                </View>
            </View>
        )
    }

    const renderSections = (data:{ item:string, index:number }) => {
        switch(data.item){
            case 'header':
                return (
                    <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                        <View transparent style={{ flex:1 }}>
                            <Text theme='h1'>MANAGE YOUR SETTINGS</Text>
                            <Text theme='description' style={{ marginTop:3 }}>Use the form below to change your group settings</Text>
                        </View>
                        <Button
                            title='X'
                            float
                            style={{ padding:10 }}
                            onPress={() => onClose()}
                        />
                    </View>
                )
            case 'settings':
                return (
                    <View transparent>
                        <FlatList
                            data={settings}
                            key={'player_settings'}
                            keyExtractor={item => item.group_key}
                            renderItem={renderGroupSettings}
                        />
                    </View>
                )
            default: return <></>
        }
    }

    return (
        <View float style={{ flex:1 }}>
            <FlatList
                data={sections}
                key={'my_settings_sections_manage'}
                keyExtractor={item => item}
                renderItem={renderSections}
            />
        </View>
    )
}

export default MySettingsForm